import { CommonModule } from '@angular/common'
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core'
import { NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { ButtonModule } from '@northfork/ng-basics'
import { CommentsDrawerComponent } from './comments-drawer/comments-drawer.component'
import { CommentsDrawerFrameComponent } from './comments-drawer/comments-drawer-frame.component'

@NgModule({
  imports: [CommonModule, NgbTooltipModule, ButtonModule],
  declarations: [CommentsDrawerComponent, CommentsDrawerFrameComponent],
  exports: [CommentsDrawerComponent, CommentsDrawerFrameComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class CommentsModule {}
